import { Component } from '@angular/core';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { AlertController, IonicPage, ToastController } from 'ionic-angular';
import { CommunicationServiceProvider } from '../../providers/communication-service/communication-service';
import { ConfigApiServiceProvider } from '../../providers/config-api-service/config-api-service';
import { DataServiceProvider } from '../../providers/data-service/data-service';
import { PriceListTableProvider } from '../../providers/price-list-table/price-list-table';


@IonicPage()
@Component({
  selector: 'page-sow',
  templateUrl: 'sow.html',
})
export class SowPage {
  editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: 'auto',
    minHeight: '0',
    maxHeight: 'auto',
    width: 'auto',
    minWidth: '0',
    translate: 'yes',
    enableToolbar: true,
    showToolbar: true,
    placeholder: 'Enter text here...',
    defaultParagraphSeparator: '',
    defaultFontName: '',
    defaultFontSize: '',
    fonts: [
      { class: 'arial', name: 'Arial' },
      { class: 'times-new-roman', name: 'Times New Roman' },
      { class: 'calibri', name: 'Calibri' },
      { class: 'comic-sans-ms', name: 'Comic Sans MS' }
    ],
    customClasses: [
      {
        name: 'quote',
        class: 'quote',
      },
      {
        name: 'redText',
        class: 'redText'
      },
      {
        name: 'titleText',
        class: 'titleText',
        tag: 'h1',
      },
    ],
    uploadWithCredentials: false,
    sanitize: false,
    toolbarPosition: 'top',
    toolbarHiddenButtons: [
    ]
  };
  htmlContent: any;
  sowMaster: any = [];
  broadcastSubs: any;
  constructor(public toastController: ToastController,private alertCtrl: AlertController,public communicationServ: CommunicationServiceProvider,public configApiService: ConfigApiServiceProvider,public dataService: DataServiceProvider, public pricelistService: PriceListTableProvider) {
  }

  ngOnInit(){
    this.dataService.showPricelistIcon = true;
    this.dataService.showPricelistSave = true;
    this.dataService.ScreenName = 'SOW';
    let currentDate: any = new Date();
    let currentMonth: any= currentDate.getMonth() + 1;
    this.dataService.uniqueId = currentDate.getDate().toString().padStart(2, '0') + currentMonth.toString().padStart(2, '0') + currentDate.getFullYear() + currentDate.getHours().toString().padStart(2, '0') + currentDate.getMinutes().toString().padStart(2, '0');
    this.initSow();
  }
  initSow(){
    this.broadcastSubs = this.communicationServ.getInstance()
    .subscribe((data: any) => {
      if(data.src ===  'proposal-view'){
        if(data.event === 'EDIT_SOW_MASTER'){
          let flag = data['status'];
          if(flag){
            this.saveSowMaster();
          }
        }
      }
    });
  }
  ngAfterViewInit(){
    var data = [];
    this.configApiService.sowMaster.forEach(element => {
      if(this.configApiService.sowId == element.uniqueId){
        this.sowMaster.push(element);
      }
    });
    this.sowMaster.forEach(element => {
      var page = document.createElement("section")
      page.setAttribute('id', 'PreiviewCount' + data.length)
      page.setAttribute('class', 'page');
      data.push(element.jsonData);
    });
    this.htmlContent = data;
  }
  ngAfterViewChecked(){
  }
  
  saveSowMaster(){
      let alert = this.alertCtrl.create({
        title: 'SOW Version',
        enableBackdropDismiss: false,
        inputs: [
          {
            name: 'VersionName',
            placeholder: 'Version Name',
            value: this.configApiService.sowVersion
          }
        ],
        buttons: [
          {
            text: 'OK',
            handler: data => {
              if (data["VersionName"].trim() == "") {
                const toast = this.toastController.create({
                  message: 'Name Cannot be Empty!',
                  duration: 5000,
                });
                toast.present();
                this.saveSowMaster();
              }else{
                let foldername: any = this.configApiService.pricelistMaster.find(item => item.versions == data.VersionName);
                if (foldername && this.pricelistService.pricelistID == '') {
                  const toast = this.toastController.create({
                    message: 'Version Name already exists.',
                    duration: 2000
                  });
                  toast.present();
                  this.saveSowMaster();
                } else {
                  let currentDate: any = new Date();
                  let currentMonth: any= currentDate.getMonth() + 1;
                  if(this.dataService.uniqueId != ''){
                    this.dataService.uniqueId = currentDate.getDate().toString().padStart(2, '0') + currentMonth.toString().padStart(2, '0') + currentDate.getFullYear() + currentDate.getHours().toString().padStart(2, '0') + currentDate.getMinutes().toString().padStart(2, '0');
                  }
                  let curentDate = currentDate.getFullYear() + '-' + currentMonth.toString().padStart(2, '0') + '-'+ currentDate.getDate().toString().padStart(2, '0');
                  let type = this.htmlContent;
                  if (typeof type == "string") {
                    var html = this.htmlContent.split("</div>,");
                    for (var i = 0; i < this.sowMaster.length; i++) {
                      this.sowMaster[i].jsonData = this.sowMaster[i].jsonData.replace(this.sowMaster[i].jsonData, html[i].concat('</div>'));
                    }
                    this.sowMaster.forEach(element => {
                      let obj1 = {
                        "Sow_Masters_1_Id": element.Sow_Masters_1_Id,
                        "currentDate": curentDate,
                        "jsonData": element.jsonData,
                        "versions": data["VersionName"],
                        "status":"",
                        "Tag":"",
                        "Created_date":"",
                        "Created_By":"",
                        "Modified_By":"",
                        "Modified_date":"",
                        "uniqueId":this.dataService.uniqueId,
                        "userid":3280,
                        "rptname":"Sow_Masters_12556",
                        "client":"starport1294"
                      }
                      let objData1 = { data: JSON.stringify(obj1) }
                      this.configApiService.saveContract(objData1).subscribe((respdata: any) => {
                        if (respdata["_POST_AddMethodResult"].length > 0) {
                          if (respdata["_POST_AddMethodResult"][0].Result !== "FAIL") {
                          }
                        }
                      });
                    });
                    this.configApiService.getSowMaster();
                  }
                }
              }
            }
          }
        ]
      });
      alert.present();
    }
  ngOnDestroy() {
    this.dataService.uniqueId = '';
    this.dataService.showPricelistIcon = false;
    this.dataService.showPricelistSave = false;
    this.broadcastSubs.unsubscribe();
  }

}




// WEBPACK FOOTER //
// ./src/pages/sow/sow.ts